import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const netradyneConfig: TSPConfig = {
  key: 'netradyne',
  name: 'Netradyne',
  category: TSPCategory.CUSTOM,
  helpText: (
    <>
      <p>To connect to Netradyne, you'll need three pieces of information:</p>
      <ol>
        <li>
          <strong>Client ID</strong>
          <ul>
            <li>This is your username provided by Netradyne support.</li>
            <li>
              If you haven't received this, contact your Netradyne
              representative.
            </li>
          </ul>
        </li>
        <li>
          <strong>Client Secret</strong>
          <ul>
            <li>This is your password provided by Netradyne support.</li>
            <li>Keep this value secure and do not share it.</li>
          </ul>
        </li>
        <li>
          <strong>Tenant Unique Name</strong>
          <ul>
            <li>
              This identifies your specific environment or account within
              Netradyne's system.
            </li>
            <li>
              Your representative will provide this value along with your
              credentials.
            </li>
          </ul>
        </li>
      </ol>
      <p>
        Once you have these values, input them below. If you're unsure about any
        of these credentials, please reach out to Netradyne support.
      </p>
    </>
  ),

  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Client ID',
          name: 'username',
          type: 'text',
          required: true,
        },
        {
          label: 'Client Secret',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'Tenant Unique Name',
          name: 'database',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default netradyneConfig;
